import produce from "immer";
import { getCurrentWeek } from "../../utils/dates";
import {
  //
  APPROVE_DROP,
  APPROVE_DROP_FAILURE,
  APPROVE_DROP_SUCCESS,
  //
  APPROVE_SWAP,
  APPROVE_SWAP_FAILURE,
  APPROVE_SWAP_SUCCESS,
  //
  CLOCK_IN,
  CLOCK_IN_FAILURE,
  CLOCK_IN_SUCCESS,
  //
  COPY_ROSTER,
  COPY_ROSTER_FAILURE,
  COPY_ROSTER_SUCCESS,
  //
  GET_SETTINGS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
  //
  REJECT_DROP,
  REJECT_DROP_FAILURE,
  REJECT_DROP_SUCCESS,
  //
  REJECT_SWAP,
  REJECT_SWAP_FAILURE,
  REJECT_SWAP_SUCCESS,
  //
  SAVE_SETTINGS,
  SAVE_SETTINGS_FAILURE,
  SAVE_SETTINGS_SUCCESS,
  SET_COPY_DATA,
  SET_DAY,
  SET_DRAG_CELL,
  SET_DRAG_SHIFT,
  SET_ROSTER,
  SET_SELECTED,
  SET_SHIFT,
  SET_WEEK,
  TOGGLE_APPROVE_MODAL,
  TOGGLE_BULK_CONFIRM,
  TOGGLE_CALENDER,
  TOGGLE_CLOCK_MODAL,
  TOGGLE_COPY,
  TOGGLE_DELETE,
  TOGGLE_DROP_MODAL,
  //
  TOGGLE_REQ_MODAL,
  TOGGLE_SUMMARY_MODAL,
  TOGGLE_VIEW,
  TOGGLE_CLOCKADD_MODAL,
  //
  UPDATE_CLOCKIN,
  UPDATE_CLOCKIN_FAILURE,
  UPDATE_CLOCKIN_SUCCESS,
  //
  UPDATE_REQUEST,
  UPDATE_REQUEST_FAILURE,
  UPDATE_REQUEST_SUCCESS,
  TOGGLE_UPDATE,
  TOGGLE_AVAIL_MODAL,
  //
  ADD_CLOCK,
  ADD_CLOCK_SUCCESS,
  ADD_CLOCK_FAILURE,
  //
  GET_PAID_HOURS,
  GET_PAID_HOURS_SUCCESS,
  GET_PAID_HOURS_FAILURE,
  //
  GET_SETTINGS_HISTORY,
  GET_SETTINGS_HISTORY_SUCCESS,
  GET_SETTINGS_HISTORY_FAILURE,
  TOGGLE_HISTORY_MODAL,
  SET_WEEK_RANGE,
  SET_ROTA_EMP,
} from "./constants";
import { endOfWeek, startOfWeek } from "date-fns";

export const initialState = {
  day: new Date(),
  weekRange: {
    startDate: startOfWeek(new Date(), { weekStartsOn: 1 }),
    endDate: endOfWeek(new Date(), { weekStartsOn: 1 }),
    key: "selection",
  },
  week: getCurrentWeek(),
  dragCell: {},
  roster: [],
  calenderOpen: false,
  dragShift: {},
  deleteConfirm: {
    open: false,
  },
  currentShift: {},
  bulkConfirm: {
    open: false,
    type: "",
  },
  shiftView: "default",
  shiftSelected: [],
  isFetchingSettings: false,
  isSaving: false,
  currentSettings: {},
  clockinModal: {
    open: false,
    currentShift: {},
  },
  isClocking: false,
  approveModal: {
    open: false,
  },
  isUpdating: false,
  dropModal: {
    open: false,
  },
  reqModal: {
    open: false,
  },
  isUpdatingRequest: false,
  summaryModal: {
    open: false,
  },
  isApprovingDrop: false,
  isRejectingDrop: false,
  isApprovingSwap: false,
  isRejectingSwap: false,
  copyMode: "none",
  isCopying: false,
  copyData: {},
  rotaToggle: false,
  availModal: {
    open: false,
  },
  clockAddModalOpen: false,
  isAddingClock: false,
  isGettingPaidHours: false,
  paidHours: {},
  isFetchingHistory: false,
  settingsHistoryModal: {
    open: false,
  },
  settingsHistory: {},
  rotaEmployee: null,
};

const RosterReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_DAY:
        draft.day = action.payload;
        break;

      case SET_WEEK:
        draft.week = action.payload;
        break;

      case SET_WEEK_RANGE:
        draft.weekRange = action.payload;
        break;

      case SET_DRAG_CELL:
        draft.dragCell = action.payload;
        break;

      case SET_ROSTER:
        draft.roster = action.payload;
        break;

      case TOGGLE_CALENDER:
        draft.calenderOpen = action.payload;
        break;

      case SET_DRAG_SHIFT:
        draft.dragShift = action.payload;
        break;

      case TOGGLE_DELETE:
        draft.deleteConfirm = action.payload;
        break;

      case SET_SHIFT:
        draft.currentShift = action.payload;
        break;

      case TOGGLE_BULK_CONFIRM:
        draft.bulkConfirm = action.payload;
        break;

      case TOGGLE_VIEW:
        draft.shiftView = action.payload;
        break;

      case SET_SELECTED:
        draft.shiftSelected = action.payload;
        break;

      case GET_SETTINGS:
        draft.isFetchingSettings = true;
        draft.currentSettings = {};
        break;
      case GET_SETTINGS_SUCCESS:
        draft.isFetchingSettings = false;
        draft.currentSettings = action.payload;
        break;
      case GET_SETTINGS_FAILURE:
        draft.isFetchingSettings = false;
        draft.currentSettings = {};
        break;

      case SAVE_SETTINGS:
        draft.isSaving = true;
        break;
      case SAVE_SETTINGS_SUCCESS:
        draft.isSaving = false;
        break;
      case SAVE_SETTINGS_FAILURE:
        draft.isSaving = false;
        break;

      case TOGGLE_CLOCK_MODAL:
        draft.clockinModal = action.payload;
        break;

      case CLOCK_IN:
        draft.isClocking = true;
        break;
      case CLOCK_IN_SUCCESS:
        draft.isClocking = false;
        break;
      case CLOCK_IN_FAILURE:
        draft.isClocking = false;
        break;

      case TOGGLE_APPROVE_MODAL:
        draft.approveModal = action.payload;
        break;

      case UPDATE_CLOCKIN:
        draft.isUpdating = true;
        break;
      case UPDATE_CLOCKIN_SUCCESS:
        draft.isUpdating = false;
        draft.clockinModal = {
          open: false,
        };
        break;
      case UPDATE_CLOCKIN_FAILURE:
        draft.isUpdating = false;
        break;

      case TOGGLE_DROP_MODAL:
        draft.dropModal = action.payload;
        break;

      case APPROVE_DROP:
        draft.isApprovingDrop = true;
        break;
      case APPROVE_DROP_SUCCESS:
        draft.isApprovingDrop = false;
        break;
      case APPROVE_DROP_FAILURE:
        draft.isApprovingDrop = false;
        break;

      case TOGGLE_REQ_MODAL:
        draft.reqModal = action.payload;
        break;

      case UPDATE_REQUEST:
        draft.isUpdatingRequest = true;
        break;
      case UPDATE_REQUEST_SUCCESS:
        draft.isUpdatingRequest = false;
        break;
      case UPDATE_REQUEST_FAILURE:
        draft.isUpdatingRequest = false;
        break;

      case APPROVE_SWAP:
        draft.isApprovingSwap = true;
        break;
      case APPROVE_SWAP_SUCCESS:
        draft.isApprovingSwap = false;
        break;
      case APPROVE_SWAP_FAILURE:
        draft.isApprovingSwap = false;
        break;

      case TOGGLE_SUMMARY_MODAL:
        draft.summaryModal = action.payload;
        break;

      case REJECT_DROP:
        draft.isRejectingDrop = true;
        break;
      case REJECT_DROP_SUCCESS:
        draft.isRejectingDrop = false;
        break;
      case REJECT_DROP_FAILURE:
        draft.isRejectingDrop = false;
        break;

      case REJECT_SWAP:
        draft.isRejectingSwap = true;
        break;
      case REJECT_SWAP_SUCCESS:
        draft.isRejectingSwap = false;
        break;
      case REJECT_SWAP_FAILURE:
        draft.isRejectingSwap = false;
        break;

      case TOGGLE_COPY:
        draft.copyMode = action.payload;
        break;

      case COPY_ROSTER:
        draft.isCopying = true;
        break;
      case COPY_ROSTER_SUCCESS:
        draft.isCopying = false;
        break;
      case COPY_ROSTER_FAILURE:
        draft.isCopying = false;
        break;

      case SET_COPY_DATA:
        draft.copyData = action.payload;
        break;

      case TOGGLE_UPDATE:
        draft.rotaToggle = action.payload;
        break;
      case TOGGLE_AVAIL_MODAL:
        draft.availModal = action.payload;
        break;

      case TOGGLE_CLOCKADD_MODAL:
        draft.clockAddModalOpen = action.payload;
        break;

      case ADD_CLOCK:
        draft.isAddingClock = true;
        break;
      case ADD_CLOCK_SUCCESS:
        draft.isAddingClock = false;
        break;
      case ADD_CLOCK_FAILURE:
        draft.isAddingClock = false;
        break;

      case GET_PAID_HOURS:
        draft.isGettingPaidHours = true;
        draft.paidHours = {};
        break;
      case GET_PAID_HOURS_SUCCESS:
        draft.isGettingPaidHours = false;
        draft.paidHours = action.payload;
        break;
      case GET_PAID_HOURS_FAILURE:
        draft.isGettingPaidHours = false;
        draft.paidHours = {};
        break;

      case GET_SETTINGS_HISTORY:
        draft.isFetchingHistory = true;
        draft.settingsHistory = {};
        break;
      case GET_SETTINGS_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.settingsHistory = action.payload;
        break;
      case GET_SETTINGS_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.settingsHistory = {};
        break;

      case TOGGLE_HISTORY_MODAL:
        draft.settingsHistoryModal = action.payload;
        break;

      case SET_ROTA_EMP:
        draft.rotaEmployee = action.payload;
        break;

      default:
        return state;
    }
  });

export default RosterReducer;
